module.exports = __webpack_public_path__ + "static/media/alipay-icon.3c7739cf.svg";